import React from "react";

export const PropertySelect = (props) => {
    const {value, onChange, options, disabled, className} = props;

    return (
        <select value={value} onChange={onChange} className={`${className ?? ""}`}>
            <option
                className="select-placeholder"
                value=""
                disabled={disabled}
                defaultValue
            >
                Please select an option
            </option>
            {options && options.sort(
                    (a, b) => a > b ? 1 : -1
                ).map((contextProp) => (
                <option key={contextProp}>{contextProp}</option>
            ))}
        </select>
    )
}